'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PATTERN = undefined;

var _lodash = require('lodash');

var PATTERN = exports.PATTERN = {
  IDCARD: new RegExp(/(^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}$)/),
  //大陆手机+澳门手机号
  MOBILE: new RegExp(
  // /^(853)?(?:28\d{6}|6\d{7})$/
  // /^[1](([3][0-9])|([4][5-9])|([5][0-3,5-9])|([6][5,6])|([7][0-8])|([8][0-9])|([9][1,8,9]))[0-9]{8}$/
  /^(0|86|17951)?(13[0-9]|14[5-9]|15[0-9]|16[124567]|17[0-8]|18[0-9]|19[0-9]|92[0-9]|98[0-9])[0-9]{8}$/)
};

exports.default = {
  idCard: {
    valid: function valid(value) {
      return !(0, _lodash.isNil)(value) && PATTERN.IDCARD.test(value);
    },
    defaultMessage: {
      en_US: '%s format error',
      zh_CN: '%s 身份证格式错误'
    }
  },
  mobile: {
    valid: function valid(value) {
      return !(0, _lodash.isNil)(value) && PATTERN.MOBILE.test(value);
    },
    defaultMessage: {
      en_US: '%s format error',
      zh_CN: '%s 手机号格式错误'
    }
  }
};